import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { PlayArrow as PlayIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export function StartExecutionButton({ onStartExecution, procedure, taskId, hasExecutions }) {
  const { t } = useTranslation(['tasks']);
  const canStartExecution = procedure.is_active && taskId && !hasExecutions;

  if (!canStartExecution) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Button
        variant="contained"
        size="large"
        startIcon={<PlayIcon />}
        onClick={onStartExecution}
        fullWidth
      >
        {t('tasks:procedure.start_execution', 'Start procedure')}
      </Button>
      <Typography variant="caption" color="text.secondary" display="block" textAlign="center" sx={{ mt: 1 }}>
        {t('tasks:procedure.start_hint', {
          count: procedure.total_steps,
          defaultValue: '{{count}} trin. Svar gemmes automatisk, så du kan stoppe og fortsætte senere.',
        })}
      </Typography>
    </Box>
  );
}
